module.exports = __webpack_public_path__ + "static/media/banff-11.0237d6fa.jpg";